import { useEffect, useState } from 'react';
const loadedImages = {};
export function useImage(url) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [size, setSize] = useState({
        width: 0,
        height: 0,
    });
    useEffect(() => {
        if (loadedImages[url]) {
            setSize({
                width: loadedImages[url][0],
                height: loadedImages[url][1],
            });
            setIsLoaded(true);
            return;
        }
        const image = new Image();
        image.addEventListener('load', () => {
            loadedImages[url] = [image.width, image.height];
            setSize({
                width: loadedImages[url][0],
                height: loadedImages[url][1],
            });
            setIsLoaded(true);
        });
        image.src = url;
    }, [url]);
    return { size, isLoaded };
}
//# sourceMappingURL=useImage.js.map